<template>
  <div>
    <v-navigation-drawer v-model="drawer" right absolute temporary>
      <v-card class="fill-height pa-0">
        <v-card-title class="py-1 px-2">
          <v-icon left>$palette</v-icon>
          Palette
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="drawer = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-row class="fill-height">
            <v-col cols="12" class="pb-0">
              <v-select
                label="Image d'origine"
                v-model="originPicture"
                :items="originPictureOptions"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  v-for="(color, index) in palette"
                  :key="index"
                  class="py-1"
                >
                  <div
                    :style="{
                      backgroundColor: color.hex,
                      color: color.hexTextColor,
                      borderRadius: '3px',
                    }"
                    class="py-1 px-2"
                  >
                    {{ color.hex.toUpperCase() }}
                  </div>
                  <v-btn
                    class="inline-block"
                    small
                    :color="
                      colors.primary.toUpperCase() == color.hex.toUpperCase()
                        ? 'primary'
                        : ''
                    "
                    @click.stop="
                      colors.primary = color.hex;
                      colors = colors;
                    "
                  >
                    Prim.
                  </v-btn>
                  <v-btn
                    class="inline-block ml-2"
                    small
                    :color="
                      colors.secondary.toUpperCase() == color.hex.toUpperCase()
                        ? 'primary'
                        : ''
                    "
                    @click.stop="colors.secondary = color.hex"
                  >
                    Sec.
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { defineComponent, ref, computed, watch } from "@vue/composition-api";
import Vibrant from "../../../node_modules/node-vibrant/dist/vibrant";

export default defineComponent({
  props: {
    disabled: Boolean,
    portalColors: {
      required: true,
      type: Object,
    },
    banner: String,
    background: String,
    open: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit, root }) {
    /* Variables */
    const originPicture = ref(null);
    const palette = ref([]);

    /* Computed */
    const colors = computed({
      get: function () {
        return props.portalColors;
      },
      set: function (value) {
        emit("update:portalColors", value);
      },
    });
    const isMobile = computed(function () {
      return root.$vuetify.breakpoint.mobile;
    });
    const originPictureOptions = computed(function () {
      return [
        { text: "Bandeau", value: 0, disabled: !hasBanner.value },
        { text: "Fond", value: 1, disabled: !hasBackground.value },
      ];
    });
    const hasBanner = computed(function () {
      return props.banner.indexOf("/banner") > -1;
    });
    const hasBackground = computed(function () {
      return props.background.indexOf("/background") > -1;
    });
    const drawer = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Watchers */
    watch(
      () => originPicture.value,
      () => {
        if (originPicture.value != null) {
          let imgSrc = "";
          if (originPicture.value == 0) {
            imgSrc = props.banner;
          } else {
            imgSrc = props.background;
          }
          Vibrant.from(imgSrc)
            .getPalette()
            .then((resultPalette) => {
              const temp = [];
              for (let color in resultPalette) {
                const rgb = resultPalette[color].getRgb();
                let textColor = "";
                if (rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114 > 186) {
                  textColor = "#000000";
                } else {
                  textColor = "#FFFFFF";
                }
                temp.push({
                  hex: resultPalette[color].getHex(),
                  hexTextColor: textColor,
                });
              }
              palette.value = temp;
            });
        }
      }
    );

    return {
      drawer,
      colors,
      isMobile,
      originPictureOptions,
      originPicture,
      palette,
    };
  },
});
</script>
